const images = {
    languages: [
        {
            img: require("../assets/languages/bash.png"),
            link: "https://www.gnu.org/software/bash/",
            name: "Bash"
        },
        {
            img: require("../assets/languages/go.png"),
            link: "https://golang.org/",
            name: "Go"
        },
        {
            img: require("../assets/languages/java.png"),
            link: "https://www.java.com/",
            name: "Java"
        },
        {
            img: require("../assets/languages/javascript.png"),
            link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
            name: "JavaScript"
        },
        {
            img: require("../assets/languages/python.png"),
            link: "https://www.python.org/",
            name: "Python"
        },
        {
            img: require("../assets/languages/rust.png"),
            link: "https://www.rust-lang.org/",
            name: "Rust"
        },
        {
            img: require("../assets/languages/typescript.png"),
            link: "https://www.typescriptlang.org/",
            name: "TypeScript"
        },
    ],
    frameworks: [
        {
            img: require("../assets/technologies-frameworks/angular.png"),
            link: "https://angular.io/",
            name: "Angular"
        },
        {
            img: require("../assets/technologies-frameworks/apollo.png"),
            link: "https://www.apollographql.com/",
            name: "Apollo"
        },
        {
            img: require("../assets/technologies-frameworks/bootstrap.png"),
            link: "https://getbootstrap.com/",
            name: "Bootstrap"
        },
        {
            img: require("../assets/technologies-frameworks/bun.png"),
            link: "https://bun.sh/",
            name: "Bun"
        },
        {
            img: require("../assets/technologies-frameworks/css.png"),
            link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
            name: "CSS"
        },
        {
            img: require("../assets/technologies-frameworks/djs.png"),
            link: "https://discord.js.org/",
            name: "Discord.js"
        },
        {
            img: require("../assets/technologies-frameworks/electron.png"),
            link: "https://www.electronjs.org/",
            name: "Electron"
        },
        {
            img: require("../assets/technologies-frameworks/express.png"),
            link: "https://expressjs.com/",
            name: "Express"
        },
        {
            img: require("../assets/technologies-frameworks/go.png"),
            link: "https://golang.org/",
            name: "Go Modules"
        },
        {
            img: require("../assets/technologies-frameworks/graphql.png"),
            link: "https://graphql.org/",
            name: "GraphQL"
        },
        {
            img: require("../assets/technologies-frameworks/hibernate.png"),
            link: "https://hibernate.org/",
            name: "Hibernate"
        },
        {
            img: require("../assets/technologies-frameworks/html.png"),
            link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
            name: "HTML"
        },
        {
            img: require("../assets/technologies-frameworks/javascript.png"),
            link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
            name: "ES6+"
        },
        {
            img: require("../assets/technologies-frameworks/nestjs.png"),
            link: "https://nestjs.com/",
            name: "NestJS"
        },
        {
            img: require("../assets/technologies-frameworks/nextjs.png"),
            link: "https://nextjs.org/",
            name: "Next.js"
        },
        {
            img: require("../assets/technologies-frameworks/nodejs.png"),
            link: "https://nodejs.org/",
            name: "Node.js"
        },
        {
            img: require("../assets/technologies-frameworks/prisma.png"),
            link: "https://www.prisma.io/",
            name: "Prisma"
        },
        {
            img: require("../assets/technologies-frameworks/puppeteer.png"),
            link: "https://pptr.dev/",
            name: "Puppeteer"
        },
        {
            img: require("../assets/technologies-frameworks/react.png"),
            link: "https://reactjs.org/",
            name: "React"
        },
        {
            img: require("../assets/technologies-frameworks/selenium.png"),
            link: "https://www.selenium.dev/",
            name: "Selenium"
        },
        {
            img: require("../assets/technologies-frameworks/socketio.png"),
            link: "https://socket.io/",
            name: "Socket.IO"
        },
        {
            img: require("../assets/technologies-frameworks/spring-boot.png"),
            link: "https://spring.io/projects/spring-boot",
            name: "Spring Boot"
        },
        {
            img: require("../assets/technologies-frameworks/tailwind.png"),
            link: "https://tailwindcss.com/",
            name: "Tailwind"
        },
    ],
}

export default images;
